const doc = [({"ko":({"adminComponentAdminTop":({"firstHotelRegistrationMessage":"시설의 등록을 해 주세요. {{num}} 시설을 등록할 수 있습니다."})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;